import { Component, Input } from '@angular/core';

import{ ListValue } from './list-value.model';

@Component({
    moduleId: module.id,
    selector: 'list',
    templateUrl: 'list.component.html'
})
export class ListComponent {
    @Input() title: string;
    @Input() subTitle: string;
    @Input() displayName: string;
    @Input() displayValue: string;
    @Input() items: ListValue[];
}


// WEBPACK FOOTER //
// ./src/app/dashboard/list/list.component.ts